import React, { createContext, useContext, useState, useEffect, useCallback, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import moment from 'moment';
import 'moment-timezone';
import { differenceInDays, parseISO } from 'date-fns';
import image from "../icons/candidates-Vacants.png";
import { secureSetItem, secureGetItem, secureRemoveItem } from '../utils/encryption';
import { getCsrfToken } from '../utils/csrf';

const RolContext = createContext();

export function RolProvider({ children }) {
  const navigate = useNavigate();

  // Recuperar datos del localStorage
  const savedUser = secureGetItem('user');
  const savedRol = secureGetItem('rol');
  const savedRolOriginal = secureGetItem('rolOriginal');
  const savedUserName = secureGetItem('userName');
  const savedProfile = secureGetItem('profile');
  const savedVacantCode = secureGetItem('vacantCode');
  const savedSelectedCompanyId = secureGetItem('selectedCompanyId');
  const savedStaff = secureGetItem('staff');
  const savedUserEmail = secureGetItem('userEmail');

  const [loading, setLoading] = useState(false);
  const [buttonPressed, setButtonPressed] = useState(false);
  const [login, setLogin] = useState(null);
  const [user, setUser] = useState(savedUser ? savedUser : null);
  const [rol, setRol] = useState(savedRol);
  const [rolOriginal, setRolOriginal] = useState(savedRolOriginal);
  const [rolActivo, setRolActivo] = useState(savedRolOriginal || savedRol);
  const [userName, setUserName] = useState(savedUserName);
  const [profile, setProfile] = useState(savedProfile ? parseInt(savedProfile) : null);
  const [vacantCode, setVacantCode] = useState(savedVacantCode);
  const [projects, setProjects] = useState(null);
  const [counts, setCounts] = useState(null);
  const [leads, setLeads] = useState(null);
  const [dataProfile, setDataProfile] = useState(null);
  const [userEmail, setUserEmail] = useState(savedUserEmail);
  const [filteredLeads, setFilteredLeads] = useState(leads);
  const [contactos, setContactos] = useState(leads);
  const [idLead, setIdLead] = useState(0);
  const [dataLead, setDataLead] = useState(null);
  const [tagUrl, setTag] = useState("todas");
  const [originUrl, setOriginUrl] = useState("todos");
  const [seguimiento, setSeguimiento] = useState("seguimiento");
  const [periodo, setPeriodo] = useState("00");
  const [visited, setVisited] = useState("todos");
  const [recruiter_id, setRecruiterId] = useState("");
  const [btnCreateLead, setBtnCreateLead] = useState(false);
  const [interest, setInterest] = useState(50);
  const [initial_comment, setInitial_Comment] = useState('Contacto creado desde V3');
  const [upLead, setUpLead] = useState(null);

  // Wrapper function for setUpLead
  const logSetUpLead = (data) => {
    setUpLead(data);
  };
  const [agePATCH, setValorSelect1] = useState(null);
  const [marital_statusPATCH, setValorSelect2] = useState(null);
  const [life_statusPATCH, setValorSelect3] = useState(null);
  const [genderPATCH, setValorSelect4] = useState(null);
  const [purchase_reasonPATCH, setValorSelect5] = useState(null);
  const [purchase_timePATCH, setValorSelect6] = useState(null);
  const [budgetPATCH, setValorSelect7] = useState(null);
  const [payment_typePATCH, setValorSelect8] = useState(null);
  const [originPATCH, setValorSelect9] = useState(null);
  const [contact_typePATCH, setValorSelect10] = useState(null);
  const [tag, setValorSelect11] = useState(null);
  const [cityPATCH, setValorInput1] = useState(null);
  const [discard, setDiscard] = useState(false)
  const [contracting_status, setContracting_Status] = useState(null)
  const [review_date, setReview_Date] = useState(null)
  const [candidate_name, setCandidate_Name] = useState(null);
  const [email, setEmail] = useState(null);
  const [phone_number, setPhone_Number] = useState(null);
  const [second_phone_number, setSecond_Phone_Number] = useState(null);
  const [second_email, setSecond_Email] = useState(null);
  const [tasksOpen, setTasksOpen] = useState(null);
  const [tasksFinished, setTasksFinished] = useState(null);
  const [tasksByLead, setTasksByLead] = useState([]);
  const [tasksByLeadOpen, setTasksByLeadOpen] = useState([]);
  const [tasksByLeadFinish, setTasksByLeadFinish] = useState([]);
  const [idTask, setIdTask] = useState(null);
  const [task, setTask] = useState(null);
  const [responsable, setResponsable] = useState(savedProfile ? parseInt(savedProfile) : null);
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  const [expiration, setExpiration] = useState(undefined);
  const [task_status, setTask_Status] = useState('Abierta');
  const [type_task, setType_Task] = useState('');
  const [candidate, setCandidate] = useState(null);
  const [newTask, setNewTask] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredContacts, setFilteredContacts] = useState(leads);
  const [activeButton, setActiveButton] = useState(1);
  const [fecha, setFecha] = useState(null);
  const [newTitle, setNewTitle] = useState('');
  const [newObservation, setNewObservation] = useState('');
  const [historial, setHistorial] = useState([])
  const [historialV3, setHistorialV3] = useState([])
  const [historialCompleto, setHistorialCompleto] = useState([])
  const [intentos, setIntentos] = useState([])
  const [intentosV3, setIntentosV3] = useState([])
  const [leadNotes, setLeadNotes] = useState(null)
  const [numIntentByLead, setNumIntentByLead] = useState({})
  const [facturacion, setFacturacion] = useState('')
  const [responseStatus, setResponseStatus] = useState(null);
  const [apiErrorMessage, setApiErrorMessage] = useState('');
  const [shouldCloseModal, setShouldCloseModal] = useState(false);
  const [errorLogin, setErrorLogin] = useState(false);
  const [isLoggingIn, setIsLoggingIn] = useState(false);
  const hasLoggedIn = useRef(false);
  const [companies, setCompanies] = useState(null);
  const [idProject, setIdProject] = useState(null);
  const [dataProject, setDataProject] = useState(null);
  const [project, setProject] = useState({
    company_id: 0,
    vacant_name: "",
    city: "",
    state: "",
    property_type: "",
    end_date: "",
    period_license: "",
    type_license: "",
    report_BI: ""
  });
  const [company, setCompany] = useState(null)
  const [vacant_name, setVacant_name] = useState("")
  const [cityP, setCity] = useState("")
  const [state, setState] = useState("")
  const [property_type, setProperty_type] = useState("")
  const [type_license, setType_license] = useState("")
  const [period_license, setPeriod_license] = useState("")
  const [end_date, setEnd_date] = useState("")
  const [report_BI, setReport_BI] = useState("")
  const [report_name, setReport_name] = useState("")
  const [selectedCompanyId, setSelectedCompanyId] = useState(savedSelectedCompanyId ? parseInt(savedSelectedCompanyId) : null);
  const [lengthProyectos, setLengthProyectos] = useState(null);
  const [listaProyectos, setListaProyectos] = useState(null);
  const [resultados, setResultados] = useState([]);
  const [lengthUser, setLengthUser] = useState(null);
  const [listaUsers, setListaUsers] = useState(null);
  const [dataUser, setDataUser] = useState(null);
  const [tradeNames, setTradeNames] = useState([]);
  const [tasksCoord, setTasksCoord] = useState([]);
  const [staff, setStaff] = useState(savedStaff === 'true');
  const [tickets, setTickets] = useState([]);
  const [titulo, setTitulo] = useState('');
  const [descripcion, setDescripcion] = useState('');
  const [tipo, setTipo] = useState('');
  const [nameUser, setNameUser] = useState('');
  const [numeroUser, setNumeroUser] = useState(null);
  const [myUser, setMyUser] = useState(null);
  const [nameMyUser, setNameMyUser] = useState('');
  const [intentCandidate, setIntentCandidate] = useState(null)
  // Estado para controlar la inicialización
  const [isInitialized, setIsInitialized] = useState(false);
  const [isLoadingAuth, setIsLoadingAuth] = useState(true);

  const BASE_URL = process.env.REACT_APP_API_URL || '';

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`${BASE_URL}/api/accounts/signIn/`, {
          method: 'POST',
          mode: 'cors',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(login),
        });

        const status = response.status;
        setResponseStatus(status);

        if (status === 404) {
          setErrorLogin(true)
          return;
        }

        if (status === 202) {
          setLoading(true);
          navigate('/Inicio');
          setTimeout(() => {
            setLoading(false);
          }, 9000)
        }

        if (!response.ok) {
          return;
        }

        const data = await response.json();
        setUser(data);
        setRolOriginal(data.rol);
        setRol(data.rol);
        setProfile(data.id);
        setResponsable(data.id);
        setUserName(data.username);
        if (data.rol === "Administrador") {
          setRol("Coordinador")
        }

        // Guardar datos en localStorage para persistencia
        secureSetItem('user', data);
        secureSetItem('rolOriginal', data.rol);
        secureSetItem('rol', data.rol === "Administrador" ? "Coordinador" : data.rol);
        secureSetItem('userName', data.username);
        secureSetItem('profile', data.id != null ? data.id.toString() : '');
        secureSetItem('staff', data.is_staff ? 'true' : 'false');

        // Resetear la bandera de login
        setIsLoggingIn(false);
      } catch (error) {
        console.error('Error:', error);
        setIsLoggingIn(false);
      }
    };

    if (buttonPressed && !isLoggingIn && login && login.email && login.password && !hasLoggedIn.current) {
      // Solo ejecutar fetchData si hay datos de login (email y password)
      // Login fetch ejecutándose
      hasLoggedIn.current = true;
      setIsLoggingIn(true);
      fetchData();
    }

    if (user && rol) {
      secureSetItem('user', user);
      secureSetItem('rol', rol);
    }
  }, [buttonPressed, login, user, rol, navigate, isLoggingIn]);

  // useEffect para restaurar sesión al cargar la página
  useEffect(() => {
    // Solo ejecutar una vez después de la inicialización
    if (!isInitialized) {
      setIsInitialized(true);

      // Verificar si hay datos de usuario en localStorage
      const savedUser = secureGetItem('user');

      if (savedUser && !buttonPressed && !login && !isLoggingIn) {
        try {
          // Si hay usuario válido y no se ha presionado el botón de login,
          // activar la restauración de sesión
          setButtonPressed(true);
          // Activar loading temporalmente para indicar que se están cargando los datos
          setLoading(true);
          setIsLoadingAuth(true);
          // Desactivar loading después de un breve delay para permitir que los datos se carguen
          setTimeout(() => {
            setLoading(false);
            setIsLoadingAuth(false);
          }, 3000); // Aumentado a 3 segundos para conexiones lentas
        } catch (error) {
          // Limpiar localStorage si hay error
          secureRemoveItem('user');
          secureRemoveItem('rol');
          secureRemoveItem('userName');
          secureRemoveItem('profile');
          setIsLoadingAuth(false);
        }
      } else {
        // Si no hay usuario guardado, marcar como no cargando
        setIsLoadingAuth(false);
      }
    }
  }, [user, buttonPressed, login, isInitialized, isLoggingIn]);

  // useEffect separado para manejar la restauración de sesión al montar el componente
  useEffect(() => {
    // Verificar si hay datos de usuario en localStorage
    const savedUser = secureGetItem('user');

    if (savedUser) {
      try {
        // Si hay usuario válido y no se ha presionado el botón de login,
        // activar la restauración de sesión
        if (!buttonPressed && !login) {
          setButtonPressed(true);
          setLoading(true);
          setTimeout(() => {
            setLoading(false);
          }, 2000);
        }
      } catch (error) {
        // Limpiar localStorage si hay error
        secureRemoveItem('user');
        secureRemoveItem('rol');
        secureRemoveItem('userName');
        secureRemoveItem('profile');
      }
    }
  }, [buttonPressed, login]); // Solo se ejecuta una vez al montar

  const Id = user ? user.id : null;

  const [ticket, setTicket] = useState({
    title: titulo,
    description: descripcion,
    type_ticket: tipo,
    id_user: Id
  })

  const addProject = useCallback((project) => {
    const apiUrl = `${BASE_URL}/api/projects`;

    fetch(apiUrl, {
      method: 'POST',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(project),
    })
      .then(response => {
        if (!response.ok) {
          throw new Error('Error al agregar proyecto');
        }
        return response.json();
      })
      .then(data => {
        setProjects(prevProjects => [...prevProjects, data]);
      })
      .catch(error => {
        console.error('Error al realizar la solicitud:', error);
      });
  }, [])

  const fetchDataProjects = useCallback(async () => {
    if (buttonPressed && Id) {
      try {
        const response = await fetch(`${BASE_URL}/api/projects/byUserId/${Id}`, {
          method: 'GET',
          mode: 'cors',
        });

        if (!response.ok) {
          throw new Error('Network response was not ok');
        }

        const data = await response.json();
        setProjects(data);
      } catch (error) {
        console.error('Error fetching projects:', error);
      }
    }
  }, [buttonPressed, Id]);

  useEffect(() => {
    fetchDataProjects();
  }, [fetchDataProjects, addProject]);

  useEffect(() => {
    if (projects && projects.length > 0) {
      // Verificar si hay un proyecto guardado en localStorage
      const savedVacantCode = secureGetItem('vacantCode');

      if (savedVacantCode) {
        // Buscar el proyecto guardado en la lista de proyectos
        let foundProject = null;
        let foundCompany = null;

        for (const company of projects) {
          const project = company.projects.find(p => p.vacant_code === savedVacantCode);
          if (project) {
            foundProject = project;
            foundCompany = company.id;
            break;
          }
        }

        if (foundProject) {
          // Usar el proyecto guardado
          setVacantCode(foundProject.vacant_code);
          setSelectedCompanyId(foundCompany);
          // Restaurando proyecto guardado
        } else {
          // Si no se encuentra, usar el primer proyecto
          const firstProject = projects[0]?.projects[0];
          const firstCompany = projects[0]?.id;

          if (firstProject) {
            setVacantCode(firstProject.vacant_code);
            setSelectedCompanyId(firstCompany);
            secureSetItem('vacantCode', firstProject.vacant_code);
            secureSetItem('selectedCompanyId', firstCompany.toString());
            // Proyecto guardado no encontrado, usando primer proyecto
          }
        }
      } else {
        // No hay proyecto guardado, usar el primer proyecto
        const firstProject = projects[0]?.projects[0];
        const firstCompany = projects[0]?.id;

        if (firstProject) {
          setVacantCode(firstProject.vacant_code);
          setSelectedCompanyId(firstCompany);
          secureSetItem('vacantCode', firstProject.vacant_code);
          secureSetItem('selectedCompanyId', firstCompany.toString());
          // No hay proyecto guardado, usando primer proyecto
        }
      }
    }
  }, [projects, addProject]); // eslint-disable-line react-hooks/exhaustive-deps

  const fetchLeadCounts = useCallback(async () => {
    if (buttonPressed && Id && vacantCode) {
      try {
        const response = await fetch(`${BASE_URL}/api/leads/count/?user_id=${Id}&vacant_code=${vacantCode}`, {
          method: 'GET',
          mode: 'cors',
        });

        if (!response.ok) {
          const errorMessage = `Network response was not ok. Status: ${response.status}`;
          throw new Error(errorMessage);
        }

        const data = await response.json();
        setCounts(data);
      } catch (error) {
        console.error('Error fetching lead counts:', error);
      }
    }
  }, [buttonPressed, Id, vacantCode]);

  useEffect(() => {
    fetchLeadCounts();
  }, [fetchLeadCounts]);

  const fetchLeadsData = useCallback(async () => {
    if (buttonPressed && Id && vacantCode) {
      try {
        setLoading(true);
        const response = await fetch(`${BASE_URL}/api/leads/filter/?user_id=${Id}&vacant_code=${vacantCode}`, {
          method: 'GET',
          mode: 'cors',
        });

        if (!response.ok) {
          throw new Error('Network response was not ok');
        }

        const data = await response.json();
        // Leads obtenidos del proyecto
        setLeads(data);
        setTimeout(() => {
          setLoading(false);
        }, 3000)
      } catch (error) {
        console.error('Error fetching leads data:', error);
        setTimeout(() => {
          setLoading(false);
        }, 9000)
      }
    }
  }, [buttonPressed, Id, vacantCode]);

  useEffect(() => {
    fetchLeadsData();
  }, [fetchLeadsData]);

  const fetchFacturacion = useCallback(async () => {
    if (buttonPressed && vacantCode) {
      try {
        const response = await fetch(`${BASE_URL}/api/projects/byProjectCode/${vacantCode}`, {
          method: 'GET',
          mode: 'cors',
        });

        if (!response.ok) {
          throw new Error('Network response was not ok');
        }

        const data = await response.json();
        setFacturacion(data);
        setReport_BI(data[0].report_BI);
        setReport_name(data[0].report_name || "");
      } catch (error) {
        console.error('Error fetching leads data:', error);
      }
    }
  }, [buttonPressed, vacantCode]);

  useEffect(() => {
    fetchFacturacion();
  }, [fetchFacturacion]);

  const fetchUserProfile = useCallback(async () => {
    if (buttonPressed && profile) {
      try {
        const response = await fetch(`${BASE_URL}/api/accounts/${profile}`, {
          method: 'GET',
          mode: 'cors',
        });

        if (!response.ok) {
          throw new Error('Network response was not ok');
        }

        const data = await response.json();
        setDataProfile(data);
        setUserEmail(data.email);
        setStaff(data.is_staff);
        if (data.rol) {
          setRolOriginal(data.rol);
          secureSetItem('rolOriginal', data.rol);
        }

        // Guardar en localStorage
        secureSetItem('userEmail', data.email);
        secureSetItem('staff', data.is_staff ? 'true' : 'false');
      } catch (error) {
        console.error('Error fetching user profile:', error);
      }
    }
  }, [buttonPressed, profile]);

  useEffect(() => {
    fetchUserProfile();
  }, [fetchUserProfile]);

  // Hydrate rolOriginal on load without depending on buttonPressed
  useEffect(() => {
    if (!profile) return;
    fetch(`${BASE_URL}/api/accounts/${profile}`)
      .then(r => r.json())
      .then(data => {
        if (data.rol) {
          setRolOriginal(data.rol);
          setRolActivo(data.rol);
          secureSetItem('rolOriginal', data.rol);
        }
      })
      .catch(() => {});
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [profile]);

  const fetchLeadDataById = useCallback(async () => {
    if (buttonPressed && idLead) {
      try {
        const response = await fetch(`${BASE_URL}/api/leads/${idLead}`, {
          method: 'GET',
          mode: 'cors',
        });

        if (!response.ok) {
          throw new Error('Network response was not ok');
        }

        const data = await response.json();
        setDataLead(data);
        setCandidate(data.id);
        setType_Task(data.contact_type);
        setContracting_Status(data.contracting_status)
        setReview_Date(data.review_date)
      } catch (error) {
        console.error('Error fetching lead data by ID:', error);
      }
    }
  }, [buttonPressed, idLead]);

  useEffect(() => {
    fetchLeadDataById();
  }, [fetchLeadDataById]);

  const fetchFilteredLeads = useCallback(async () => {
    if (buttonPressed && Id && vacantCode) {
      try {
        // Si el rol es Asesor, usar automáticamente su ID como recruiter_id
        let recruiterIdParam;
        if (rol === 'Asesor') {
          recruiterIdParam = Id;
        } else {
          recruiterIdParam = recruiter_id || "";
        }

        const response = await fetch(`${BASE_URL}/api/leads/filter/?user_id=${Id}&vacant_code=${vacantCode}&tag=${tagUrl}&origin=${originUrl}&seguimiento=${seguimiento}&periodo=${periodo}&visited=${visited}&recruiter_id=${recruiterIdParam}`, {
          method: 'GET',
          mode: 'cors',
        });

        if (!response.ok) {
          throw new Error('Network response was not ok');
        }

        const data = await response.json();


        setLeads(data);
      } catch (error) {
        console.error('Error fetching filtered leads:', error);
      }
    }
  }, [buttonPressed, Id, vacantCode, tagUrl, originUrl, seguimiento, periodo, visited, recruiter_id, rol]);

  useEffect(() => {
    // Solo ejecutar fetchFilteredLeads si no es un asesor (para evitar doble ejecución)
    if (rol !== 'Asesor') {
      fetchFilteredLeads();
    }
  }, [fetchFilteredLeads, rol]);

  // useEffect para establecer automáticamente recruiter_id para asesores
  useEffect(() => {
    if (rol === 'Asesor' && Id) {
      setRecruiterId(Id);
    }
  }, [rol, Id]);

  // useEffect para forzar recarga inmediata cuando el rol sea Asesor
  useEffect(() => {
    if (rol === 'Asesor' && Id && vacantCode && buttonPressed) {
      // Ejecutar fetchFilteredLeads inmediatamente para asesores
      fetchFilteredLeads();
    }
  }, [rol, Id, vacantCode, buttonPressed, fetchFilteredLeads]);

  // Función para validar si el correo o teléfono ya existe en el proyecto
  const validateLeadExists = useCallback(async (email, phone_number, vacant_code) => {
    if (!email && !phone_number) {
      return { exists: false, message: null };
    }

    try {
      // Validar localmente contra los leads existentes
      if (leads && Array.isArray(leads)) {
        const existingLead = leads.find(lead => {
          // Verificar si el email coincide (si se proporciona email)
          if (email && lead.email && lead.email.toLowerCase() === email.toLowerCase()) {
            return true;
          }
          // Verificar si el teléfono coincide (si se proporciona teléfono)
          if (phone_number && lead.phone_number && lead.phone_number === phone_number) {
            return true;
          }
          return false;
        });

        if (existingLead) {
          // Buscar el nombre del asesor responsable
          let recruiterName = 'otro asesor';
          if (listaUsers && Array.isArray(listaUsers)) {
            const recruiter = listaUsers.find(user => user.id === existingLead.recruiter);
            if (recruiter) {
              recruiterName = `${recruiter.first_name} ${recruiter.last_name}`;
            }
          }

          return {
            exists: true,
            message: `El contacto ya existe en este proyecto y está siendo atendido por ${recruiterName}. No se puede agregar un contacto duplicado.`
          };
        }
      }

      return { exists: false, message: null };
    } catch (error) {
      console.error('Error validando lead:', error);
      return { exists: false, message: null };
    }
  }, [leads, listaUsers]);

  const createLead = useCallback(async () => {
    if (btnCreateLead && upLead) {
      try {
        // Validar si el lead ya existe antes de crear
        const validation = await validateLeadExists(upLead.email, upLead.phone_number, upLead.vacant_code);

        if (validation.exists) {
          setApiErrorMessage(validation.message);
          setBtnCreateLead(false);
          setUpLead(null);
          setShouldCloseModal(false);
          return;
        }

        // Si no existe, proceder con la creación
        const response = await fetch(`${BASE_URL}/api/leads`, {
          method: 'POST',
          mode: 'cors',
          headers: {
            'Content-Type': 'application/json',
            'X-CSRFToken': getCsrfToken(),
          },
          body: JSON.stringify(upLead),
        });

        if (!response.ok) {
          // Try to get the error response body
          const errorText = await response.text();
          try {
            const errorData = JSON.parse(errorText);
            if (errorData.message) {
              setApiErrorMessage(errorData.message);
            } else {
              setApiErrorMessage(`Error ${response.status}: ${response.statusText}`);
            }
          } catch (parseError) {
            setApiErrorMessage(`Error ${response.status}: ${response.statusText}`);
          }

          throw new Error(`Network response was not ok: ${response.status} ${response.statusText} - ${errorText}`);
        }

        const data = await response.json();
        setLeads(prevArray => [...prevArray, data]);

        // Clear any previous error messages
        setApiErrorMessage('');

        // Reset the button state
        setBtnCreateLead(false);

        // Reset upLead to null
        setUpLead(null);

        // Signal to close the modal
        setShouldCloseModal(true);
      } catch (error) {
        console.error('Error creating lead:', error);

        // Reset the button state on error
        setBtnCreateLead(false);

        // Reset upLead to null on error
        setUpLead(null);

        // Don't close modal on error
        setShouldCloseModal(false);

        // Note: apiErrorMessage is already set in the error handling above
      }
    }
  }, [btnCreateLead, upLead, setLeads, validateLeadExists]);

  useEffect(() => {
    createLead();
  }, [createLead]);

  const initialPostulationDate = dataLead ? dataLead.postulation_date || '' : '';
  const initialVisitedDate = dataLead ? dataLead.visited_date || null : null;

  const [postulation_date, setValorInput2] = useState(initialPostulationDate);
  const [visited_date, setValorInput3] = useState(initialVisitedDate);

  const handlePatchRequest = useCallback(() => {
    const params = {
      age: agePATCH,
      marital_status: marital_statusPATCH,
      life_status: life_statusPATCH,
      gender: genderPATCH,
      purchase_reason: purchase_reasonPATCH,
      purchase_time: purchase_timePATCH,
      budget: budgetPATCH,
      payment_type: payment_typePATCH,
      origin: originPATCH,
      contact_type: contact_typePATCH,
      tag,
      city: cityPATCH,
      discard,
      visited_date,
    };

    const filteredParams = Object.fromEntries(
      Object.entries(params).filter(([key, value]) => value !== undefined)
    );

    const apiUrl = `${BASE_URL}/api/leads/${idLead}`;

    fetch(apiUrl, {
      method: 'PATCH',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(filteredParams),
    })
      .then(response => response.json())
      .then(data => {
        setDataLead(data);
      })
      .catch(error => {
        console.error('Error al realizar la solicitud:', error);
      });
  }, [idLead,
    agePATCH,
    marital_statusPATCH,
    life_statusPATCH,
    genderPATCH,
    purchase_reasonPATCH,
    purchase_timePATCH,
    budgetPATCH,
    payment_typePATCH,
    originPATCH,
    contact_typePATCH,
    tag,
    cityPATCH,
    discard,
    visited_date
  ]);

  const handlePatch2Request = useCallback(() => {
    const params2 = {
      candidate_name,
      email,
      phone_number,
      second_phone_number,
      second_email,
    };

    const filteredParams2 = Object.fromEntries(
      Object.entries(params2).filter(([key, value]) => value !== undefined)
    );

    const apiUrl = `${BASE_URL}/api/leads/${idLead}`;

    fetch(apiUrl, {
      method: 'PATCH',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(filteredParams2),
    })
      .then(response => response.json())
      .then(data => {
        setDataLead(data);
      })
      .catch(error => {
        console.error('Error al realizar la solicitud:', error);
      });

    if (candidate_name === null) {
      setDataLead();
    }
    const textElements = document.querySelectorAll('.img-profile-perfilContacto');
    textElements.forEach((element) => {
      const text = element.textContent;
      const firstLetter = document.createElement('span');
      firstLetter.className = 'primera-letra';
      firstLetter.textContent = text[0];
      element.textContent = '';
      element.appendChild(firstLetter);
    });
  }, [idLead, candidate_name, email, phone_number, second_phone_number, second_email]);

  const fetchTasks = useCallback(() => {
    if (buttonPressed && Id) {
      fetch(`${BASE_URL}/api/tasks`, {
        method: 'GET',
        mode: 'cors',
      })
        .then(response => response.json())
        .then(data => {
          setTasksCoord(data)
          const filteredTasksOpen = data.filter(task => task.responsable === Id && task.task_status === 'Abierta');
          setTasksOpen(filteredTasksOpen);
          const filteredTasksFinish = data.filter(task => task.responsable === Id && task.task_status === 'Finalizada');
          setTasksFinished(filteredTasksFinish);
        })
    }
  }, [buttonPressed, Id, setTasksOpen, setTasksFinished]);

  useEffect(() => {
    fetchTasks();
  }, [fetchTasks]);

  useEffect(() => {
    fetch(`${BASE_URL}/api/tasks/${idTask}`, {
      method: 'GET',
      mode: 'cors',
    })
      .then(response => response.json())
      .then(data => {
        setTask(data);
      });
  }, [idTask]);

  const handlePatchTasksRequest = useCallback(() => {
    const paramsTask = {
      title,
      description,
      expiration,
      task_status,
      type_task,
      responsable
    };

    const apiUrl = `${BASE_URL}/api/tasks/${idTask}`;

    fetch(apiUrl, {
      method: 'PATCH',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(paramsTask),
    })
      .then(response => response.json())
      .then(data => {
        setTask(data);
      })
      .catch(error => {
        console.error('Error al realizar la solicitud:', error);
      });
  }, [idTask, title, description, expiration, task_status, type_task, responsable]);

  const handlePosthTasksByLeadRequest = useCallback(() => {
    const paramsTaskByLead = {
      responsable,
      title,
      description,
      expiration,
      task_status,
      type_task,
      candidate,
    };

    const apiUrl = `${BASE_URL}/api/tasks`;

    fetch(apiUrl, {
      method: 'POST',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRFToken': getCsrfToken(),
      },
      body: JSON.stringify(paramsTaskByLead),
    })
      .then(response => response.json())
      .then(data => {
        setTasksOpen(prevArray => [...prevArray, data]);
        setTasksByLeadOpen(prevArray => [...(prevArray || []), data]);
      })
      .catch(error => {
        console.error('Error al realizar la solicitud:', error);
      });
  }, [responsable, title, description, expiration, task_status, type_task, candidate, setTasksOpen, setTasksByLeadOpen]);

  const handleClickProceso = useCallback(() => {
    const url = `${BASE_URL}/api/tasks/${idTask}`;
    const data = {
      task_status: 'Finalizada',
    };

    fetch(url, {
      method: 'PATCH',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRFToken': getCsrfToken(),
      },
      body: JSON.stringify(data),
    })
      .then(response => {
        if (!response.ok) {
          throw new Error('Error en la solicitud');
        }
        return response.json();
      })
      .then(data => {
        setTask(data);
        setTasksOpen(tasksOpen.filter(item => item.id !== data.id));
        setTasksFinished([...tasksFinished, data]);
      })
      .catch(error => {
        console.error('Error en la solicitud PATCH:', error);
      });
  }, [idTask, setTask, tasksOpen, setTasksOpen, tasksFinished, setTasksFinished]);

  const handleClickFinalizada = useCallback(() => {
    const url = `${BASE_URL}/api/tasks/${idTask}`;
    const data = {
      task_status: 'Abierta',
    };

    fetch(url, {
      method: 'PATCH',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    })
      .then(response => {
        if (!response.ok) {
          throw new Error('Error en la solicitud');
        }
        return response.json();
      })
      .then(data => {
        setTask(data);
        setTasksFinished(tasksFinished.filter(item => item.id !== data.id));
        setTasksOpen([...tasksOpen, data]);
      })
      .catch(error => {
        console.error('Error en la solicitud PATCH:', error);
      });
  }, [idTask, setTask, tasksOpen, setTasksOpen, tasksFinished, setTasksFinished]);

  useEffect(() => {
    const fechaActual = new Date();
    setFecha(fechaActual);
  }, []);

  const handleTagChange = async (e, contactId) => {
    const newTag = e.target.value;

    try {
      await fetch(`${BASE_URL}/api/leads/${contactId}`, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRFToken': getCsrfToken(),
        },
        body: JSON.stringify({ tag: newTag }),
      });
      setLeads((prevContacts) =>
        prevContacts.map((contact) =>
          contact.id === contactId ? { ...contact, tag: newTag } : contact
        )
      );
    } catch (error) {
      console.error('Error al actualizar el tag:', error);
    }
  };

  const handleContractingStatusChange = async (e, contactId) => {
    const newContractingStatus = e.target.value;

    try {
      await fetch(`${BASE_URL}/api/leads/${contactId}`, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRFToken': getCsrfToken(),
        },
        body: JSON.stringify({ contracting_status: newContractingStatus }),
      });
      setLeads((prevContacts) =>
        prevContacts.map((contact) =>
          contact.id === contactId ? { ...contact, contracting_status: newContractingStatus } : contact
        )
      );
    } catch (error) {
      console.error('Error al actualizar el contracting_status:', error);
    }
  };

  const handleNotesCreate = async (titleOverride) => {
    const requestData = {
      title: titleOverride !== undefined ? titleOverride : newTitle,
      observation: newObservation,
      candidate: idLead,
      user: Id,
      type_note: "intento"
    };

    try {
      const response = await fetch(`${BASE_URL}/api/notes`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRFToken': getCsrfToken(),
        },
        body: JSON.stringify(requestData),
      });

      if (!response.ok) {
        const errorText = await response.text();
        console.error('❌ Error en la respuesta:', {
          status: response.status,
          statusText: response.statusText,
          body: errorText
        });
        throw new Error(`HTTP ${response.status}: ${response.statusText}`);
      }

      const data = await response.json();

      // Actualizar historialCompleto para que se refleje en la vista
      setHistorialCompleto((prevHistorial) => {
        const newHistorial = [...prevHistorial, data].sort((a, b) => new Date(b.created) - new Date(a.created));
        return newHistorial;
      });

      // También mantener actualizado intentosV3 para compatibilidad
      setIntentosV3((prevNotes) => {
        const newNotes = [...prevNotes, data];
        return newNotes;
      });
    } catch (error) {
      console.error('💥 ERROR AL CREAR LA NOTA:');
      console.error('   Tipo de error:', error.name);
      console.error('   Mensaje:', error.message);
      console.error('   Stack:', error.stack);
      console.error('   Datos que se intentaron enviar:', requestData);
    }
  };

  const handlePatchDiscard = useCallback(() => {

    const apiUrl = `${BASE_URL}/api/leads/${idLead}`;

    const data = {
      discard: true,
    };

    return fetch(apiUrl, {
      method: 'PATCH',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRFToken': getCsrfToken(),
      },
      body: JSON.stringify(data),
    })
      .then(response => response.json())
      .then(updatedLead => {
        setDataLead(updatedLead);
        setLeads(prevLeads => prevLeads && Array.isArray(prevLeads) ? prevLeads.filter(lead => lead.id !== idLead) : []);
      })
      .catch(error => {
        console.error('Error al realizar la solicitud:', error);
        throw error;
      });
  }, [idLead, setLeads, setDataLead]);

  const handlePatchSeleccion = useCallback(() => {

    const apiUrl = `${BASE_URL}/api/leads/${idLead}`;

    const data = {
      discard: false,
    };

    fetch(apiUrl, {
      method: 'PATCH',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRFToken': getCsrfToken(),
      },
      body: JSON.stringify(data),
    })
      .then(response => response.json())
      .then(updatedLead => {
        setDataLead(updatedLead);
        setLeads(prevLeads => prevLeads && Array.isArray(prevLeads) ? prevLeads.filter(lead => lead.id !== idLead) : []);
      })
      .catch(error => {
        console.error('Error al realizar la solicitud:', error);
      });
  }, [idLead, setLeads, setDataLead]);

  useEffect(() => {
    if (!idLead) return;
    setTasksByLead([]);
    setTasksByLeadOpen([]);
    setTasksByLeadFinish([]);
    const controller = new AbortController();
    fetch(`${BASE_URL}/api/tasks?lead=${idLead}`, {
      method: 'GET',
      mode: 'cors',
      headers: { 'Content-Type': 'application/json' },
      signal: controller.signal,
    })
      .then(response => response.json())
      .then(data => {
        setTasksByLead(data);
        if (data && Array.isArray(data)) {
          setTasksByLeadOpen(data.filter(task => task.task_status === 'Abierta'));
          setTasksByLeadFinish(data.filter(task => task.task_status === 'Finalizada'));
        } else {
          setTasksByLeadOpen([]);
          setTasksByLeadFinish([]);
        }
      })
      .catch(err => { if (err.name !== 'AbortError') console.error('[tasks fetch]', err); });
    return () => controller.abort();
  }, [idLead]);


  // Fetch para obtener todo el historial del lead (sin filtrar por tipo)
  useEffect(() => {
    if (!idLead || idLead <= 0) {
      setHistorialCompleto([]);
      return;
    }
    setHistorialCompleto([]);
    const controller = new AbortController();
    const fetchHistorialCompleto = async () => {
      try {
        const response = await fetch(`${BASE_URL}/api/notes/byLeadId?lead=${idLead}`, {
          headers: { 'Content-Type': 'application/json' },
          signal: controller.signal,
        });
        if (!response.ok) throw new Error(`HTTP ${response.status}`);
        const data = await response.json();
        if (Array.isArray(data)) {
          setHistorialCompleto(data.sort((a, b) => new Date(b.created) - new Date(a.created)));
        } else {
          setHistorialCompleto([]);
        }
      } catch (error) {
        if (error.name !== 'AbortError') {
          console.error('Error al obtener historial completo:', error);
          setHistorialCompleto([]);
        }
      }
    };
    fetchHistorialCompleto();
    return () => controller.abort();
  }, [idLead]);

  useEffect(() => {
    const fetchDataWithRetry = async (retries = 3, delay = 2000) => {
      for (let i = 0; i < retries; i++) {
        try {
          // Crear un AbortController para timeout personalizado
          const controller = new AbortController();
          const timeoutId = setTimeout(() => controller.abort(), 60000); // 60 segundos timeout

          const response = await fetch(`${BASE_URL}/api/notes/byLeadId?lead=${idLead}`, {
            signal: controller.signal,
            headers: {
              'Content-Type': 'application/json',
            },
            // Aumentar timeout para peticiones lentas
            timeout: 60000
          });

          clearTimeout(timeoutId);

          // Verificar si la respuesta es HTML (error de CloudFront)
          const contentType = response.headers.get('content-type');
          if (contentType && contentType.includes('text/html')) {
            const htmlText = await response.text();
            if (htmlText.includes('504 Gateway Timeout') || htmlText.includes('ERROR: The request could not be satisfied')) {
              throw new Error('Error 504 Gateway Timeout de CloudFront');
            }
            throw new Error('Respuesta HTML recibida en lugar de JSON');
          }

          if (!response.ok) {
            throw new Error(`HTTP ${response.status}: ${response.statusText}`);
          }

          const data = await response.json();

          if (Array.isArray(data)) {
            // Filtrar por type_note: 'accion' para obtener las acciones reales
            const accionesFiltradas = data.filter(note => note.type_note === 'accion');
            setHistorial(accionesFiltradas);
            const sortedData = accionesFiltradas.sort((a, b) => new Date(b.created) - new Date(a.created));
            setHistorialV3(sortedData);
            return; // Éxito, salir del bucle de reintentos
          } else {
            console.error('Error: La respuesta de la API no es un array');
            return; // Error de formato, no reintentar
          }

        } catch (error) {
          console.error(`Error en intento ${i + 1} para obtener historial:`, error.message);

          if (i === retries - 1) {
            // Último intento fallido
            console.error('Todos los intentos fallaron para obtener el historial del lead:', idLead);
            // Opcional: mostrar mensaje al usuario o establecer estado de error
            setHistorial([]);
            setHistorialV3([]);
          } else {
            // Esperar antes del siguiente intento
            await new Promise(resolve => setTimeout(resolve, delay));
            delay *= 1.5; // Incrementar delay exponencialmente
          }
        }
      }
    };

    if (idLead && idLead > 0) {
      fetchDataWithRetry();
    } else {
      setHistorial([]);
      setHistorialV3([]);
    }
  }, [idLead]);

  useEffect(() => {
    // Para asesores, asegurar que solo se muestren sus leads
    if (rol === 'Asesor' && leads && Array.isArray(leads)) {
      const filteredLeads = leads.filter(lead => lead.recruiter === Id);
      setFilteredContacts(filteredLeads);
    } else if (leads && Array.isArray(leads)) {
      setFilteredContacts(leads);
    } else {
      setFilteredContacts([]);
    }
  }, [leads, rol, Id])

  const handleButtonClickIndicadores = (buttonId) => {
    let newActiveButton;

    // Base filter para asesores
    const baseFilter = rol === 'Asesor' ? (item) => item.recruiter === Id : () => true;

    // Verificar que leads sea un array válido
    if (!leads || !Array.isArray(leads)) {
      setFilteredContacts([]);
      return;
    }

    switch (buttonId) {
      case 2:
      case 3:
      case 4:
      case 5:
      case 6:
        newActiveButton = buttonId === activeButton ? null : buttonId;
        setFilteredContacts(
          leads.filter(
            (item) =>
              baseFilter(item) &&
              item.candidate_name.toLowerCase().includes(searchTerm.toLowerCase()) &&
              item.contracting_status === getStatusForButton(buttonId)
          )
        );
        break;
      case 7:
        newActiveButton = 1;
        setFilteredContacts(
          leads.filter((lead) => {
            const fechaActual = moment();
            const fechaLead = moment(lead.review_date);
            const diferenciaEnDias = fechaLead.diff(fechaActual, 'days');
            return baseFilter(lead) && diferenciaEnDias < -22 && lead.contracting_status !== 'Cierre';
          })
        );
        break;
      default:
        newActiveButton = buttonId === activeButton ? null : buttonId;
        setFilteredContacts(
          leads.filter((item) =>
            baseFilter(item) &&
            item.candidate_name.toLowerCase().includes(searchTerm.toLowerCase())
          )
        );
        break;
    }

    setActiveButton(newActiveButton);

    if (activeButton === buttonId || (activeButton >= 2 && activeButton <= 6)) {
      setActiveButton(buttonId);
    } else {
      setActiveButton(buttonId);
    }
  };

  const getStatusForButton = (buttonId) => {
    const statusMap = {
      2: "Calificado",
      3: "Cita",
      4: "Visita",
      5: "Potencial",
      6: "Cierre",
    };
    return statusMap[buttonId] || "";
  };

  // Función para determinar el tipo de búsqueda basado en el input
  const getSearchType = (searchValue) => {
    if (!searchValue) return 'name';

    // Si en algún momento escriben @, es un email
    if (searchValue.includes('@')) {
      return 'email';
    }

    // Si empiezan con números o contienen números, es un teléfono
    if (/\d/.test(searchValue)) {
      return 'phone';
    }

    // Si solo contiene letras (y espacios), es un nombre
    return 'name';
  };

  useEffect(() => {
    // Base filter para asesores
    const baseFilter = rol === 'Asesor' ? (item) => item.recruiter === Id : () => true;

    // Verificar que leads sea un array válido
    if (!leads || !Array.isArray(leads)) {
      setFilteredContacts([]);
      return;
    }

    const filtered = searchTerm
      ? leads.filter((item) => {
        if (!baseFilter(item)) return false;

        const searchType = getSearchType(searchTerm);
        const lowerSearchTerm = searchTerm.toLowerCase();

        switch (searchType) {
          case 'email':
            return item.email?.toLowerCase().includes(lowerSearchTerm);
          case 'phone':
            return item.phone_number?.toLowerCase().includes(lowerSearchTerm);
          case 'name':
          default:
            return item.candidate_name?.toLowerCase().includes(lowerSearchTerm);
        }
      })
      : leads.filter(baseFilter);

    setFilteredContacts(filtered);
  }, [searchTerm, leads, setFilteredContacts, rol, Id]);

  useEffect(() => {
    const fetchData = async () => {
      if (buttonPressed && Id) {
        try {
          const response = await fetch(`${BASE_URL}/api/companies/byUserId/${Id}`);
          const data = await response.json();
          setCompanies(data);
        } catch (error) {
          console.error('Error al realizar la solicitud de fetch:', error);
        }
      }
    };

    fetchData();
  }, [buttonPressed, Id])

  const fetchDataProyecto = useCallback(async () => {
    if (buttonPressed && idProject) {
      const apiUrl = `${BASE_URL}/api/projects/${idProject}`
      try {
        const response = await fetch(apiUrl);
        const data = await response.json();
        setCompany(data.company);
        setVacant_name(data.vacant_name);
        setCity(data.city);
        setState(data.state);
        setProperty_type(data.property_type);
        setType_license(data.type_license);
        setPeriod_license(data.period_license);
        setEnd_date(data.end_date);
      } catch (error) {
        console.error('Error al realizar la solicitud de fetch de los datos de Proyecto :', error);
      }
    }
  }, [buttonPressed, idProject])

  const handlePatchProyecto = useCallback(() => {

    const apiUrl = `${BASE_URL}/api/projects/${idProject}`;

    const data = {
      company: company,
      vacant_name: vacant_name,
      city: cityP,
      state: state,
      property_type: property_type,
      end_date: end_date,
      period_license: period_license,
      type_license: type_license,
      report_BI: report_BI,
    };

    fetch(apiUrl, {
      method: 'PATCH',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    })
      .then(response => response.json())
      .then(newData => {
        setDataProject(newData)
      })
      .catch(error => {
        console.error('Error al realizar la solicitud:', error);
      });
  }, [
    idProject,
    company,
    vacant_name,
    cityP,
    state,
    property_type,
    type_license,
    period_license,
    end_date,
    report_BI,
  ]);

  useEffect(() => {
    fetchDataProyecto();
  }, [idProject, fetchDataProyecto]);

  useEffect(() => { setProjects(projects) }, [projects, addProject])

  useEffect(() => {
    const fetchData = async () => {
      if (buttonPressed && selectedCompanyId) {
        try {
          const response = await fetch(`${BASE_URL}/api/projects/byCompanyId/${selectedCompanyId}`);
          const data = await response.json();
          setLengthProyectos(data.length);
          setListaProyectos(data)
          const resultadosCalculados = data.map((project) => {
            const fechaDesdeAPI = parseISO(project.end_date);
            const fechaHoy = new Date();
            const diffDays = differenceInDays(fechaHoy, fechaDesdeAPI);
            return { id: project.id, resultado: diffDays >= 0 ? 'Si' : 'No' };
          });

          setResultados(resultadosCalculados);
        } catch (error) {
          console.error('Error al realizar la solicitud de fetch:', error);
        }
      }
    };

    fetchData();
  }, [buttonPressed, selectedCompanyId])

  useEffect(() => {
    const fetchData = async () => {
      if (buttonPressed && selectedCompanyId) {
        try {
          const response = await fetch(`${BASE_URL}/api/companies/${selectedCompanyId}`);
          const data = await response.json();
          const userPromises = data.user.map(async (userId) => {
            const userResponse = await fetch(`${BASE_URL}/api/accounts/${userId}`);
            const userData = await userResponse.json();
            return {
              id: userId,
              first_name: userData.first_name,
              last_name: userData.last_name,
              email: userData.email,
              username: userData.username,
              rol: userData.rol,
              is_staff: userData.is_staff,
              is_active: userData.is_active,
              date_joined: userData.date_joined
            };
          });
          const userDataArray = await Promise.all(userPromises);
          setLengthUser(userDataArray.length)
          setListaUsers(userDataArray);
        } catch (error) {
          console.error('Error al solicitar usuarios por compañía:', error);
        }
      }
    };

    fetchData();
  }, [buttonPressed, selectedCompanyId]);

  const fetchUserTeam = useCallback(async (id) => {
    try {
      const response = await fetch(`${BASE_URL}/api/accounts/${id}`, {
        method: 'GET',
        mode: 'cors',
      });

      if (!response.ok) {
        throw new Error('Network response was not ok');
      }

      const data = await response.json();
      setDataUser(data);


      const findTradeNamesByUser = (userArray, targetNumber) => {
        const foundCompanies = companies.filter(company => company.user.includes(targetNumber));

        const foundTradeNames = foundCompanies.map(company => company.trade_name);
        setTradeNames(foundTradeNames);

        if (foundTradeNames.length === 0) {
          setTradeNames(['No se encontró el número en ninguna empresa']);
        }
      };

      const targetNumber = id;
      findTradeNamesByUser(companies.map(company => company.user), targetNumber);
    } catch (error) {
      console.error('Error fetching user profile:', error);
    }
  }, [companies]);

  const updateUserTeam = useCallback(async (id, fields) => {
    try {
      const response = await fetch(`${BASE_URL}/api/accounts/${id}`, {
        method: 'PATCH',
        mode: 'cors',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(fields),
      });
      if (!response.ok) throw new Error('Error al actualizar usuario');
      const data = await response.json();
      setDataUser(data);
      setListaUsers(prev => prev
        ? prev.map(u => u.id === id ? { ...u, ...fields } : u)
        : prev
      );
      return { success: true };
    } catch (error) {
      console.error('Error al actualizar usuario:', error);
      return { success: false };
    }
  }, []);

  const buildUrl = useCallback(() => {
    if (staff) {
      return `${BASE_URL}/api/tickets/?role=Staff`;
    } else if (rol === 'Asesor') {
      return `${BASE_URL}/api/tickets/?rol=${rol}&id_user=${Id}`;
    } else {
      return `${BASE_URL}/api/tickets/?rol=${rol}&company=${selectedCompanyId}`;
    }
  }, [Id, rol, selectedCompanyId, staff]);

  useEffect(() => {
    let isMounted = true;

    const fetchData = async () => {
      if (buttonPressed) {
        try {
          const url = buildUrl();
          const respuesta = await fetch(url);

          if (!respuesta.ok) {
            throw new Error(`Error al llamar a la API de tickets. Status: ${respuesta.status}, URL: ${url}`);
          }

          const datosJson = await respuesta.json();

          if (isMounted) {
            setTickets(datosJson);
          }
        } catch (error) {
          console.error('Error al llamar a la API de Tickets:', error.message);
        }
      }
    };

    fetchData();

    return () => {
      isMounted = false;
    };
  }, [buttonPressed, Id, rol, selectedCompanyId, staff, buildUrl]);

  const crearTicket = async () => {
    try {
      const url = `${BASE_URL}/api/tickets/`;

      // Configuración del request
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(ticket),
      });

      // Verificar si la respuesta es exitosa
      if (!response.ok) {
        throw new Error(`Error en la solicitud de creación de ticket: ${response.statusText}`);
      }

      // Procesar la respuesta
      const data = await response.json();

      // Actualizar el estado de los tickets
      setTickets((prevTickets) => [data, ...prevTickets]);

    } catch (error) {
      // Manejar errores durante la llamada a la API
      console.error('Error al llamar a la API de Tickets:', error.message);
    }
  };

  useEffect(() => {
    const fetchUserData = async () => {
      if (buttonPressed && numeroUser) {
        try {
          const response = await fetch(`${BASE_URL}/api/accounts/${numeroUser}`, {
            method: 'GET',
            mode: 'cors',
          });

          if (!response.ok) {
            throw new Error('Network response was not ok');
          }

          const data = await response.json();
          const name = data.first_name + ' ' + data.last_name;
          setNameUser(name);
        } catch (error) {
          console.error('Error fetching user profile:', error.message);
        }
      }
    };

    fetchUserData();
  }, [buttonPressed, numeroUser]);

  useEffect(() => {
    const fetchUserData = async () => {
      if (buttonPressed && myUser) {
        try {
          const response = await fetch(`${BASE_URL}/api/accounts/${myUser}`, {
            method: 'GET',
            mode: 'cors',
          });

          if (!response.ok) {
            throw new Error('Network response was not ok');
          }

          const data = await response.json();
          const name = data.first_name + ' ' + data.last_name;
          setNameMyUser(name);
        } catch (error) {
          console.error('Error fetching user profile:', error.message);
        }
      }
    };

    fetchUserData();
  }, [buttonPressed, myUser]);

  // Función para cerrar sesión y limpiar datos
  const logout = useCallback(() => {
    // Limpiar localStorage
    secureRemoveItem('user');
    secureRemoveItem('rol');
    secureRemoveItem('userName');
    secureRemoveItem('profile');
    secureRemoveItem('vacantCode');
    secureRemoveItem('selectedCompanyId');
    secureRemoveItem('staff');
    secureRemoveItem('userEmail');

    // Resetear estados del contexto
    setUser(null);
    setRol(null);
    setUserName(null);
    setProfile(null);
    setVacantCode(null);
    setSelectedCompanyId(null);
    setStaff(false);
    setUserEmail(null);
    setButtonPressed(false);
    setLogin(null);
    setIsLoggingIn(false);
    hasLoggedIn.current = false;
    setProjects(null);
    setCounts(null);
    setLeads(null);
    setDataProfile(null);
    setResponsable(null);

    // Navegar a la página de login
    navigate('/sign-in');

  }, [navigate]);


  return (
    <RolContext.Provider
      value={{
        Id,
        rol,
        setRol,
        rolActivo,
        setRolActivo,
        rolOriginal,
        staff,
        projects,
        setProjects,
        counts,
        setCounts,
        vacantCode,
        setVacantCode,
        login,
        setLogin,
        user,
        setUser,
        buttonPressed,
        setButtonPressed,
        loading,
        setLoading,
        isInitialized,
        isLoadingAuth,
        leads,
        setLeads,
        dataProfile,
        setDataProfile,
        filteredLeads,
        setFilteredLeads,
        contactos,
        setContactos,
        dataLead,
        setDataLead,
        idLead,
        setIdLead,
        tagUrl,
        setTag,
        originUrl,
        setOriginUrl,
        seguimiento,
        setSeguimiento,
        periodo,
        setPeriodo,
        visited,
        setVisited,
        recruiter_id,
        setRecruiterId,
        setBtnCreateLead,
        upLead,
        setUpLead: logSetUpLead,
        apiErrorMessage,
        setApiErrorMessage,
        shouldCloseModal,
        setShouldCloseModal,
        interest,
        setInterest,
        initial_comment,
        setInitial_Comment,
        agePATCH,
        setValorSelect1,
        marital_statusPATCH,
        setValorSelect2,
        life_statusPATCH,
        setValorSelect3,
        genderPATCH,
        setValorSelect4,
        purchase_reasonPATCH,
        setValorSelect5,
        purchase_timePATCH,
        setValorSelect6,
        budgetPATCH,
        setValorSelect7,
        payment_typePATCH,
        setValorSelect8,
        originPATCH,
        setValorSelect9,
        contact_typePATCH,
        setValorSelect10,
        tag,
        setValorSelect11,
        cityPATCH,
        setValorInput1,
        postulation_date,
        setValorInput2,
        visited_date,
        setValorInput3,
        handlePatchRequest,
        candidate_name,
        setCandidate_Name,
        email,
        setEmail,
        phone_number,
        setPhone_Number,
        second_phone_number,
        setSecond_Phone_Number,
        second_email,
        setSecond_Email,
        handlePatch2Request,
        tasksOpen,
        setTasksOpen,
        tasksFinished,
        setTasksFinished,
        idTask,
        setIdTask,
        task,
        setTask,
        title,
        setTitle,
        description,
        setDescription,
        expiration,
        setExpiration,
        task_status,
        setTask_Status,
        handlePatchTasksRequest,
        responsable,
        setResponsable,
        type_task,
        setType_Task,
        candidate,
        setCandidate,
        newTask,
        setNewTask,
        handlePosthTasksByLeadRequest,
        tasksByLeadOpen,
        setTasksByLeadOpen,
        tasksByLeadFinish,
        setTasksByLeadFinish,
        activeButton,
        setActiveButton,
        filteredContacts,
        setFilteredContacts,
        searchTerm,
        setSearchTerm,
        handleClickProceso,
        handleClickFinalizada,
        fecha,
        setFecha,
        userEmail,
        setUserEmail,
        handleTagChange,
        handleContractingStatusChange,
        newTitle,
        setNewTitle,
        newObservation,
        setNewObservation,
        handleNotesCreate,
        userName,
        setUserName,
        discard,
        setDiscard,
        handlePatchDiscard,
        handlePatchSeleccion,
        contracting_status,
        setContracting_Status,
        review_date,
        setReview_Date,
        image,
        handleButtonClickIndicadores,
        historial,
        setHistorial,
        historialV3,
        historialCompleto,
        setHistorialCompleto,
        intentos,
        setIntentos,
        leadNotes,
        setLeadNotes,
        intentCandidate,
        setIntentCandidate,
        numIntentByLead,
        setNumIntentByLead,
        facturacion,
        fetchTasks,
        responseStatus,
        errorLogin,
        setErrorLogin,
        companies,
        setCompanies,
        addProject,
        idProject,
        setIdProject,
        dataProject,
        setDataProject,
        project,
        setProject,
        company,
        setCompany,
        vacant_name,
        setVacant_name,
        cityP,
        setCity,
        state,
        setState,
        property_type,
        setProperty_type,
        type_license,
        setType_license,
        period_license,
        setPeriod_license,
        end_date,
        setEnd_date,
        handlePatchProyecto,
        report_BI,
        setReport_BI,
        report_name,
        selectedCompanyId,
        setSelectedCompanyId,
        lengthProyectos,
        setLengthProyectos,
        listaProyectos,
        setListaProyectos,
        resultados,
        setResultados,
        lengthUser,
        listaUsers,
        dataUser,
        fetchUserTeam,
        updateUserTeam,
        tradeNames,
        tasksCoord,
        tickets,
        setTickets,
        ticket,
        setTicket,
        crearTicket,
        titulo,
        setTitulo,
        descripcion,
        setDescripcion,
        tipo,
        setTipo,
        tasksByLead,
        intentosV3,
        nameUser,
        setNumeroUser,
        setMyUser,
        nameMyUser,
        logout,
        validateLeadExists,
      }}
    >
      {children}
    </RolContext.Provider>
  );
}

export function useRol() {
  return useContext(RolContext);
}